import { Component, OnInit, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ScanPriority } from '../../../models/scan-priority';

import { NotyService } from '../../../services/common/noty.service';
import { ScanPriorityService } from '../../../services/documents/scan-priority.service';

@Component({
  selector: 'app-scan-priority-index',
  templateUrl: './scan-priority-index.component.html',
  styleUrls: ['./scan-priority-index.component.scss'],
})
export class ScanPriorityIndexComponent implements OnInit {
  loading: boolean = true;

  newScanPriority: ScanPriority = new ScanPriority();

  scanPriorities: Array<ScanPriority> = [];

  scanPriorityToDelete: ScanPriority;

  constructor(private modalService: NgbModal, private notyService: NotyService, private scanPriorityService: ScanPriorityService) {}

  ngOnInit() {
    this.loadScanPriorities();
  }

  delete(scanPriority: ScanPriority, index: number) {
    scanPriority.deleting = true;
    this.scanPriorityService
      .delete(scanPriority.id)
      .then((response_json) => {
        scanPriority.deleting = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Scan priority deleted', 'warning');
          this.scanPriorities.splice(index, 1);
        } else this.notyService.notify(response_json.text || 'Error deleting scan priority', 'error');
      })
      .catch(() => {
        scanPriority.deleting = false;
        this.notyService.notify('Error deleting scan priority', 'error');
      });
  }

  deleteModal(scanPriority: ScanPriority, index: number, modalTemplate: TemplateRef<any>) {
    this.scanPriorityToDelete = scanPriority;
    this.modalService.open(modalTemplate).result.then(
      (result) => {
        if (result == 'delete') this.delete(scanPriority, index);
      },
      (reason) => {}
    );
  }

  loadScanPriorities() {
    this.loading = true;
    this.scanPriorityService
      .index()
      .then((response_json) => {
        this.loading = false;
        this.scanPriorities = response_json;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  save(scanPriority: ScanPriority) {
    scanPriority.saving = true;
    this.scanPriorityService
      .save(scanPriority)
      .then((response_json) => {
        scanPriority.saving = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Scan priority saved', 'success');
          if (scanPriority.priorityChanged) this.loadScanPriorities();
          else if (!scanPriority.id) {
            this.loadScanPriorities();
            this.newScanPriority = new ScanPriority();
          } else {
            scanPriority.changed = false;
            scanPriority.priorityChanged = false;
          }
        } else this.notyService.notify(response_json.text || 'Error saving scan priority', 'error');
      })
      .catch(() => {
        scanPriority.saving = false;
        this.notyService.notify('Error saving scan priority', 'error');
      });
  }
}
